import {
  ExploreAggColumnType,
  exploreAggColumnTypeToLabel,
  ExploreColumnType,
  exploreColumnTypeToLabel,
  ExploreGroupByColumnType,
  exploreGroupByColumnTypeToLabel,
} from "@/v2/entities/explore/columns/ExploreColum.model";

export interface DisplayOptions {
  groupBy?: ExploreGroupByColumnType;
  orderBy?: AllowedInteractionOrderBy | AllowedAggOrderBy;
  orderDir?: "asc" | "desc";
  columns?: ExploreColumnType[];
  aggColumns?: ExploreAggColumnType[];
  aggOrderBy?: AllowedAggOrderBy | null;
  aggOrderDir?: "asc" | "desc" | null;
}

export interface ExploreDisplayOptionsProps {
  value: DisplayOptions;
  onChange: (value: DisplayOptions) => void;
  source: "tickets" | "conversations";
  selectedColumns: ExploreColumnType[];
}

export type AllowedInteractionOrderBy =
  | "interactionType"
  | "tenantId"
  | "id"
  | "displayId"
  | "subject"
  | "description"
  | "createdAt"
  | "updatedAt"
  | "status"
  | "channel"
  | "topic"
  | "subTopic"
  | "category"
  | "agentAssigned"
  | "team"
  | "teams"
  | "tenantUser"
  | "tenantOrganization"
  | "tags"
  | "avgQaScore"
  | "avgAutoQaScore"
  | "avgQaScoreRoundRange"
  | "avgSentiment"
  | "csat"
  | "countPublicMessages"
  | "countInternalMessages"
  | "timeToResolution"
  | "timeToFirstResponse"
  | "countQuackMessages"
  | "isQuackAnswered"
  | "isAnsweredByAui"
  | "isQuackEscalated"
  | "collaborators"
  | "isFiniteState"
  | "validationStatus"
  | "agentAssignedId"
  | "ticketId"
  | "solvedAt"
  | "scorecard"
  | "scorecards"
  | "originAuthor"
  | "resolutionStatus"
  | "escalationReason"
  | "skipReason"
  | "resolvedReason"
  | "originUrl"
  | "scoreTitle"
  | "scoreContent"
  | "simulatorId"
  | "isUserAuthenticated";

export type AllowedAggOrderBy =
  | "volume"
  | "volumeRatio"
  | "avgQuackMessages"
  | "avgQaScore"
  | "avgAutoQaScore"
  | "avgQaScoreByTitle"
  | "avgQaScoreByContent"
  | "avgSentiment"
  | "avgCsat"
  | "avgTimeToResolution"
  | "avgTimeToFirstResponse"
  | "avgPublicMessages"
  | "avgInternalMessages"
  | "countAgentsAssigned";

export const exploreOrderByTypeToLabel: Record<
  AllowedInteractionOrderBy | AllowedAggOrderBy | ExploreGroupByColumnType,
  string
> = {
  ...exploreColumnTypeToLabel,
  ...exploreAggColumnTypeToLabel,
  ...exploreGroupByColumnTypeToLabel,
  interactionType: "Interaction Type",
  solvedAt: "Solved At",
  scorecard: "Scorecard",
  scorecards: "Scorecards",
  tenantId: "Tenant ID",
  status: "Status",
  channel: "Channel",
  topic: "Topic",
  category: "Category",
  resolutionStatus: "Resolution Status",
  escalationReason: "Escalation Reason",
  skipReason: "Skipped Reason",
  resolvedReason: "Resolved Reason",
  subTopic: "Intent",
  agentAssigned: "Agent",
  team: "Team",
  week: "Week",
  day: "Day",
  month: "Month",
  avgQaScore: "Avg QA Score",
  avgQaScoreRoundRange: "Avg QA Score",
  avgQuackMessageScoreRoundRange: "Avg Quack Message Score",
  avgSentiment: "Avg Sentiment",
  isQuackAnswered: "Quack Answered",
  isAnsweredByAui: "Answered by AUI",
  scoreTitle: "Score Title",
  scoreContent: "Score Content",
  originUrl: "Origin URL",
  simulator: "AI Agent",
  skillUsed: "Skill Used",
  avgCsat: "Avg CSAT",
  isUserAuthenticated: "Is User Authenticated",
};
